(function() { window.GUID_7651cd01_2e64_408c_a6f2_67d1a134f20c = { getGuid: function() { return "7651cd01-2e64-408c-a6f2-67d1a134f20c"; } }; })();
//TODO:POP
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Popup extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.delegate = null;
                this.closeOnOverlayClick = false;
            }
            static set _currentAjaxModalUrl(value) {
                Popup.currentAjaxModalUrl = value;
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            get $Overlay() {
                return this.$Control.find(".overlay");
            }
            get $PopupInner() {
                return this.$Control.find(".popup-inner");
            }
            get CloseOnOverlayClick() {
                return this.closeOnOverlayClick;
            }
            MovePopupButtonsToFooter() {
                const outsideFooterButtons = this.$Control.find(".popup-button:not(.in-footer)");
                if (outsideFooterButtons.length > 0) {
                    this.$Control.find(".popup-footer > div").append(outsideFooterButtons);
                }
            }
            RemoveFooterPopupButtons() {
                this.$Control.find(".popup-footer .popup-button").remove();
            }
            OnControlInstantiation(params) {
                if (this.baseParam.$element != null) {
                    this.$control = this.baseParam.$element;
                    this.controlId = this.$control.attr("id");
                }
                else {
                    this.controlId = params[0];
                    this.$control = $("#" + params[0]); //contient le Id
                }
                let me = this;
                me.Proceed = false;
                var existing = CS.DOM.$body.find("#" + me.ControlId + ".inbody");
                if (existing.length > 0) {
                    existing.remove();
                }
                this.$Control.appendTo(CS.DOM.$body);
                this.$Control.addClass("inbody");
                this.MovePopupButtonsToFooter();
                if (this.$Control.hasClass("popup--confetti")) {
                    this.showConfetti = true;
                }
                CS.DOM.$body.offon("ajaxnavigating.popup-" + this.ControlId, function () {
                    me.Dispose();
                });
            }
            saveUrlAndData(url, data) {
                this.Url = url;
                this.Data = data;
            }
            cleanUpCurrentModal() {
                if (Popup.CurrentModal &&
                    Popup.CurrentModal.ControlId == this.ControlId) {
                    Popup.CurrentModal = null;
                    Popup.currentAjaxModalUrl = null;
                }
            }
            OnDispose() {
                if (this.OnDisposeDelegate) {
                    this.OnDisposeDelegate();
                }
                if (this.showConfetti) {
                    CS.Helper.ConfettiHelper.stop();
                }
                this.cleanUpCurrentModal();
                CS.DOM.DisposeChilds(this.$Control);
                this.$Control.off("keyup." + this.UniqueNamespace).off("click");
                CS.DOM.$body.off(`mousedown.${this.ControlId}`);
                this.currentCallback = null;
                this.$Control.remove();
                this.constructor.currentAjaxModalUrl = null;
                CS.Ajax.AjaxListener.Remove(this.delegate);
            }
            OnBindEvents() {
                let me = this;
                this.$Control.offon("click." + me.UniqueNamespace, ".popup-footer .button, .popup-header .button, .popup-content .close-popup-button", function () {
                    me.Proceed = false;
                    me.ClickedButtonId = this.id;
                    if ($(this).hasClass("proceed")) {
                        me.Proceed = true;
                    }
                    me.Close();
                });
                if (this.showConfetti) {
                    CS.Lag(this.ControlId, 1000, () => {
                        if (this.$Control.find(".popup-inner").length) {
                            CS.Helper.ConfettiHelper.start(this.$Control.find(".popup-inner"));
                            CS.Lag(this.ControlId, 3000, () => {
                                if (this.$Control.find(".popup-inner").length) {
                                    CS.Helper.ConfettiHelper.stop();
                                }
                            });
                        }
                    });
                }
            }
            static Show(content, disableAutoFocus = false) {
                let me = this;
                let $content = $(content);
                let popupObject = new me(null, new Controls.ControlBaseParam(null, null, $content));
                popupObject.DisposeOnClose = true;
                popupObject.Show(disableAutoFocus);
            }
            static ShowModal(content, onLoadCallback, callback, closeOnOverlayClick = false, closeLastModal = false, disableAutoFocus = false) {
                let me = this;
                Popup.closeCurrentModalIfNeeded(closeLastModal);
                let $content = $(content);
                let popupObject = new me(null, new Controls.ControlBaseParam(null, null, $content));
                popupObject.DisposeOnClose = true;
                Popup.CurrentModal = popupObject.ShowModal(onLoadCallback, callback, closeOnOverlayClick, null, null, disableAutoFocus);
            }
            static ShowAjaxModalWithForm(url, data, onLoadCallback, callback, closeOnOverlayClick = false, closeLastModal = false, disableAutoFocus = false) {
                let me = this;
                this.ShowAjaxModal(url, data, ({ popup, isPopup }) => {
                    if (isPopup) {
                        popup.InnerForm = CS.Controls.GetInstance(CS.Controls.Form, popup.$Control.find("form"));
                        popup.InnerForm.$Control.data("nonav", true);
                        popup.InnerForm.OnSubmitedCallback = (response) => {
                            popup.FormResponse = response;
                            popup.Proceed = true;
                            callback({ popup: popup });
                        };
                        if (onLoadCallback) {
                            onLoadCallback({ popup: popup });
                        }
                        popup.saveUrlAndData(url, data);
                    }
                }, ({ popup }) => {
                    if (popup.Proceed) {
                        popup.InnerForm.Submit();
                    }
                }, closeOnOverlayClick, closeLastModal, disableAutoFocus);
            }
            static ShowAjaxModal(url, data, onLoadCallback, callback, closeOnOverlayClick = false, closeLastModal = false, disableAutoFocus = false) {
                let me = this;
                Popup.closeCurrentModalIfNeeded(closeLastModal);
                if (me.currentAjaxModalUrl != null && me.currentAjaxModalUrl == url) {
                    return;
                }
                CS.Ajax.Get(url, data, function (response) {
                    me.currentAjaxModalUrl = url;
                    let $response = $(response);
                    if (Popup.testIfIsNotAPopup($response)) {
                        onLoadCallback({
                            popup: $response,
                            isPopup: false,
                        });
                        return;
                    }
                    let popupObject = new me(null, new Controls.ControlBaseParam(null, null, $response));
                    popupObject.DisposeOnClose = true;
                    Popup.CurrentModal = popupObject.ShowModal(onLoadCallback, callback, closeOnOverlayClick, null, null, disableAutoFocus);
                    Popup.CurrentModal.saveUrlAndData(url, data);
                });
            }
            static ShowAjaxModalPost(url, data, onLoadCallback, callback, closeLastModal = false) {
                let me = this;
                Popup.closeCurrentModalIfNeeded(closeLastModal);
                if (me.currentAjaxModalUrl != null && me.currentAjaxModalUrl == url) {
                    return;
                }
                CS.Ajax.Post(url, data, function (response) {
                    me.currentAjaxModalUrl = url;
                    let $response = $(response);
                    let popupObject = new me(null, new Controls.ControlBaseParam(null, null, $response));
                    popupObject.DisposeOnClose = true;
                    Popup.CurrentModal = popupObject.ShowModal(onLoadCallback, callback, null, url, data);
                });
            }
            static testIfIsNotAPopup($response) {
                let isPopup = $response.hasClass("popup") || $response.hasClass("popupwizard");
                return !isPopup;
            }
            static ShowMessage(message, htmlMessage) {
                let me = this;
                let data = { message };
                let url = CS.Url.CSUrl("displaymessagepopup");
                CS.Ajax.Get(url, data, function (response) {
                    me.currentAjaxModalUrl = url;
                    let $response = $(response);
                    let popupObject = new me(null, new Controls.ControlBaseParam(null, null, $response));
                    popupObject.DisposeOnClose = true;
                    Popup.CurrentModal = popupObject.ShowModal(null, null, true, null, null);
                    Popup.CurrentModal.saveUrlAndData(url, data);
                    if (htmlMessage) {
                        popupObject.$Control.find(".popup-message").html(htmlMessage);
                    }
                });
            }
            static ShowAreYouSure(callback, overrideMessage) {
                CS.Controls.Popup.ShowAjaxModal(CS.Url.CSUrl("showareyousuremodal"), null, function ({ popup, isPopup }) {
                    if (isPopup) {
                        if (overrideMessage) {
                            const $message = popup.$Control.find("#are-you-sure-message");
                            if ($message.length) {
                                $message.text(overrideMessage);
                            }
                        }
                    }
                }, function ({ popup }) {
                    if (popup.Proceed) {
                        callback();
                    }
                });
            }
            static closeCurrentModalIfNeeded(closeLastModal) {
                if (closeLastModal && Popup.CurrentModal) {
                    Popup.CurrentModal.Close();
                    Popup.currentAjaxModalUrl = null;
                }
            }
            ShowModal(onLoadCallback, callback, closeOnOverlayClick = false, url = null, data = null, disableAutoFocus = false) {
                let me = this;
                me.currentCallback = callback;
                this.closeOnOverlayClick = closeOnOverlayClick;
                me.delegate = (state, extraParams) => {
                    if (state == CS.Ajax.AjaxState.CallEnded) {
                        onLoadCallback.call(this, {
                            popup: me,
                            isPopup: true,
                        });
                        CS.Ajax.AjaxListener.Remove(me.delegate);
                    }
                };
                if (onLoadCallback != null) {
                    CS.Ajax.AjaxListener.OnAjaxStateChange(me.delegate);
                }
                me.saveUrlAndData(url, data);
                me.Show(disableAutoFocus);
                return me;
            }
            CloseWithNoCallback() {
                this.currentCallback = null;
                this.Close();
            }
            Close(goBack = true) {
                let me = this;
                me.IsPopupVisible = false;
                if (me.currentCallback != null) {
                    me.currentCallback.call(this, {
                        popup: me,
                    });
                    if (!me.PreventCloseOnce)
                        me.currentCallback = null;
                    //Evite quil soit reclancher comme dans le post de la matchcard
                    else {
                        me.PreventCloseOnce = false;
                        return;
                    }
                }
                this.cleanUpCurrentModal();
                if (this.DisposeOnClose) {
                    this.$Control.off("keyup." + this.UniqueNamespace).off("click");
                    CS.DOM.$body.off(`mousedown.${this.ControlId}`);
                    CS.DOM.$body.off(`click.${this.ControlId}`);
                    this.$Overlay.off(`click.${this.ControlId}`);
                }
                const isDrawerVariant = this.$PopupInner.data("xyz");
                if (isDrawerVariant) {
                    me.$PopupInner.removeClass("xyz-in");
                    me.$PopupInner.addClass("xyz-out");
                    CS.Lag(this.ControlId, 250, () => {
                        me.$control.animate({ opacity: "0" }, 100, () => {
                            me.$control.hide();
                            if (me.DisposeOnClose) {
                                me.constructor.currentAjaxModalUrl = null;
                                me.Dispose();
                            }
                        });
                    });
                }
                else {
                    me.$control.animate({ opacity: "0" }, 250, () => {
                        me.$control.hide();
                        me.constructor.currentAjaxModalUrl = null;
                        if (me.DisposeOnClose) {
                            me.Dispose();
                        }
                    });
                }
                if (this.$Control.hasClass("popup--under-bottom-bar") &&
                    CS.DOM.$sectionBottom.length) {
                    CS.DOM.$sectionBottom.removeClass("no-box-shadow");
                }
                if (goBack) {
                    CS.PopState.GoBackIfNotAlreadyDone();
                }
                this.Trigger(Popup.EventNames.PopupClose);
            }
            Show(disableAutoFocus = false) {
                let me = this;
                if (this.$Control.hasClass("popup--under-bottom-bar") &&
                    CS.DOM.$sectionBottom.length) {
                    const bottomHeight = CS.DOM.$sectionBottom.outerHeight();
                    CS.DOM.$sectionBottom.addClass("no-box-shadow");
                    const drawerBottom = bottomHeight - 1;
                    this.$PopupInner.css({
                        bottom: `${drawerBottom}px`,
                    });
                }
                if (this.closeOnOverlayClick) {
                    if (this.$Control.hasClass("popup--no-overlay")) {
                        CS.DOM.$body.offon(`mousedown.${this.ControlId}`, (e) => {
                            let $target = $(e.target);
                            let $dropdown = $target.closest(".dropdown");
                            let $closestPopup;
                            if ($dropdown.length > 0) {
                                let dropDown = CS.Controls.GetInstance(Controls.DropDown, $dropdown);
                                if (dropDown) {
                                    $closestPopup =
                                        dropDown.CurrentPicker.$Control.closest(".popup");
                                }
                            }
                            if (!$closestPopup) {
                                $closestPopup = $target.closest(".popup");
                            }
                            if ($closestPopup.attr("id") != this.ControlId) {
                                this.Close();
                            }
                        });
                    }
                    else {
                        this.$Overlay.offon(`click.${this.ControlId}`, (e) => {
                            this.Close();
                        });
                    }
                }
                CS.PopState.WaitForPop(me.ControlId, () => {
                    //Don't call back from popstate, otherwise it closes the parent popup
                    me.Close(false);
                });
                this.IsPopupVisible = true;
                let $firstFocusableElement = me.trapFocusInModal();
                const isDrawerVariant = me.$PopupInner.data("xyz");
                if (isDrawerVariant) {
                    me.$PopupInner.removeClass("xyz-out");
                    me.$PopupInner.addClass("xyz-in");
                }
                me.$Control.show(1, () => {
                    me.$Control.append("<style> body {overflow: hidden;} </style>");
                    me.$control.animate({ opacity: "1" }, 250, () => {
                        if (!disableAutoFocus) {
                            const $firstInput = me.$control.find(":input:not(input[type=button],input[type=submit],button):visible:first");
                            if ($firstInput.length > 0) {
                                $firstInput.focus();
                                $firstInput.select();
                            }
                        }
                    });
                });
                this.Trigger(Popup.EventNames.PopupShow);
            }
            trapFocusInModal() {
                var $tabbable = this.$Control.find("a, input, select, textarea");
                var $firstTabbable = $tabbable.first();
                var $lastTabbable = $tabbable.last();
                /*redirect last tab to first input*/
                $lastTabbable.offon("keydown." + this.UniqueNamespace, function (e) {
                    if (e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        $firstTabbable.focus();
                    }
                });
                /*redirect first shift+tab to last input*/
                $firstTabbable.offon("keydown." + this.UniqueNamespace, function (e) {
                    if (e.which === 9 && e.shiftKey) {
                        e.preventDefault();
                        $lastTabbable.focus();
                    }
                });
                return $firstTabbable;
            }
            Refresh(callback, extraData) {
                let me = this;
                if (extraData) {
                    this.Url = CS.Ajax.AppendDataToUrl(this.Url, extraData);
                }
                CS.Ajax.Get(this.Url, this.Data, function (response) {
                    let $response = $(response);
                    let oldForm = CS.Controls.GetInstance(CS.Controls.Form, me.$Control.find(".csform"), true);
                    if (oldForm) {
                        oldForm.Singletone = true;
                    }
                    me.$Control.find(".popup-content")[0].innerHTML =
                        $response.find(".popup-content")[0].innerHTML;
                    if (oldForm) {
                        let $newForm = me.$Control.find(".csform");
                        oldForm.$Control = $newForm;
                    }
                    if (callback) {
                        callback.call(this);
                    }
                });
            }
        }
        Controls.Popup = Popup;
        (function (Popup) {
            class Events {
                static PopupShow(params) {
                    Controls.RegisterEvent(Popup, EventNames.PopupShow, params);
                }
                static PopupClose(params) {
                    Controls.RegisterEvent(Popup, EventNames.PopupClose, params);
                }
            }
            Popup.Events = Events;
            class EventNames {
            }
            EventNames.PopupShow = "popup-show";
            EventNames.PopupClose = "popup-close";
            Popup.EventNames = EventNames;
        })(Popup = Controls.Popup || (Controls.Popup = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=popup.js.map
